import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./components/layout/Layout";

// Main Pages
import HomePage from "./pages/HomePage";
import LLCUSAPage from "./pages/LLCUSAPage";
import LTDUKPage from "./pages/LTDUKPage";
import CanadaPage from "./pages/CanadaPage";
import RegisteredAgentPage from "./pages/RegisteredAgentPage";
import NorthwestReviewPage from "./pages/NorthwestReviewPage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import RatgeberPage from "./pages/RatgeberPage";

// Legal Pages
import ImpressumPage from "./pages/ImpressumPage";
import DatenschutzPage from "./pages/DatenschutzPage";
import HaftungsausschlussPage from "./pages/HaftungsausschlussPage";
import AffiliateOffenlegungPage from "./pages/AffiliateOffenlegungPage";
import NutzungsbedingungenPage from "./pages/NutzungsbedingungenPage";

// Guide Pages
import BesteLLCServicesPage from "./pages/guides/BesteLLCServicesPage";
import LLCWyomingPage from "./pages/guides/LLCWyomingPage";
import { EINNummerPage, USBankkontoPage } from "./pages/guides/GenericGuidePage";

// Placeholder component for guides not yet fully implemented
const GuidePlaceholder = ({ title }) => (
  <div className="py-12">
    <div className="container-wide">
      <h1 className="mb-6">{title}</h1>
      <p className="text-slate-600">
        Dieser Ratgeber wird in Kürze verfügbar sein. Besuchen Sie unsere{" "}
        <a href="/ratgeber" className="text-teal-600 hover:text-teal-700">
          Ratgeber-Übersicht
        </a>{" "}
        für weitere Informationen.
      </p>
    </div>
  </div>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Layout>
          <Routes>
            {/* Main Pages */}
            <Route path="/" element={<HomePage />} />
            <Route path="/llc-usa-gruenden" element={<LLCUSAPage />} />
            <Route path="/ltd-uk-gruenden" element={<LTDUKPage />} />
            <Route path="/firma-gruenden-kanada" element={<CanadaPage />} />
            <Route path="/registered-agent" element={<RegisteredAgentPage />} />
            <Route path="/northwest-registered-agent-erfahrungen" element={<NorthwestReviewPage />} />
            <Route path="/ueber-uns" element={<AboutPage />} />
            <Route path="/kontakt" element={<ContactPage />} />
            <Route path="/ratgeber" element={<RatgeberPage />} />

            {/* Legal Pages */}
            <Route path="/impressum" element={<ImpressumPage />} />
            <Route path="/datenschutz" element={<DatenschutzPage />} />
            <Route path="/haftungsausschluss" element={<HaftungsausschlussPage />} />
            <Route path="/affiliate-offenlegung" element={<AffiliateOffenlegungPage />} />
            <Route path="/nutzungsbedingungen" element={<NutzungsbedingungenPage />} />

            {/* Guide Pages - Fully Implemented */}
            <Route path="/ratgeber/beste-llc-gruendungsservices-vergleich" element={<BesteLLCServicesPage />} />
            <Route path="/ratgeber/llc-wyoming-gruenden" element={<LLCWyomingPage />} />
            <Route path="/ratgeber/ein-nummer-beantragen" element={<EINNummerPage />} />
            <Route path="/ratgeber/us-bankkonto-eroeffnen-auslaender" element={<USBankkontoPage />} />

            {/* Guide Pages - Placeholders */}
            <Route path="/ratgeber/llc-delaware-gruenden" element={<GuidePlaceholder title="LLC in Delaware gründen — Vorteile, Kosten & Anleitung" />} />
            <Route path="/ratgeber/llc-florida-gruenden" element={<GuidePlaceholder title="LLC in Florida gründen — Leitfaden für internationale Gründer" />} />
            <Route path="/ratgeber/llc-new-mexico-gruenden" element={<GuidePlaceholder title="LLC in New Mexico gründen — Maximale Anonymität" />} />
            <Route path="/ratgeber/llc-texas-gruenden" element={<GuidePlaceholder title="LLC in Texas gründen — Alles was Sie wissen müssen" />} />
            <Route path="/ratgeber/operating-agreement-llc" element={<GuidePlaceholder title="Operating Agreement für Ihre LLC — Warum es unverzichtbar ist" />} />
            <Route path="/ratgeber/registered-agent-wechseln" element={<GuidePlaceholder title="Registered Agent wechseln — So geht's einfach" />} />
            <Route path="/ratgeber/llc-vs-gmbh-vergleich" element={<GuidePlaceholder title="LLC vs. GmbH — Vergleich für deutsche Unternehmer" />} />
            <Route path="/ratgeber/llc-fuer-amazon-fba" element={<GuidePlaceholder title="LLC für Amazon FBA — Brauchen Sie eine?" />} />
            <Route path="/ratgeber/llc-freelancer-digitale-nomaden" element={<GuidePlaceholder title="LLC für Freelancer und Digitale Nomaden" />} />
            <Route path="/ratgeber/annual-report-llc" element={<GuidePlaceholder title="Jahresbericht (Annual Report) für Ihre LLC — Was Sie beachten müssen" />} />
            <Route path="/ratgeber/virtual-office-llc" element={<GuidePlaceholder title="Virtual Office für Ihre LLC — Brauchen Sie eins?" />} />
            <Route path="/ratgeber/llc-aufloesen" element={<GuidePlaceholder title="LLC auflösen — Schritt-für-Schritt Anleitung" />} />
            <Route path="/ratgeber/ltd-england-vs-schottland" element={<GuidePlaceholder title="LTD gründen: England vs. Schottland — Unterschiede erklärt" />} />
            <Route path="/ratgeber/firmenkonto-uk-eroeffnen" element={<GuidePlaceholder title="Firmenkonto in Großbritannien eröffnen — Guide für Ausländer" />} />
            <Route path="/ratgeber/corporation-ontario-gruenden" element={<GuidePlaceholder title="Corporation in Ontario gründen — Schritt für Schritt" />} />
            <Route path="/ratgeber/llc-kosten-ueberblick" element={<GuidePlaceholder title="Was kostet eine LLC? — Alle Kosten im Überblick 2026" />} />
            <Route path="/ratgeber/serie-llc-erklaert" element={<GuidePlaceholder title="Serie LLC — Was ist das und für wen lohnt sie sich?" />} />
            <Route path="/ratgeber/itin-beantragen-anleitung" element={<GuidePlaceholder title="ITIN beantragen — Anleitung für nicht-US-Bürger" />} />
            <Route path="/ratgeber/llc-immobilien-usa" element={<GuidePlaceholder title="LLC für Immobilien-Investitionen in den USA" />} />
            <Route path="/ratgeber/digitale-produkte-verkaufen-llc" element={<GuidePlaceholder title="Digitale Produkte verkaufen mit einer US-LLC" />} />
            <Route path="/ratgeber/llc-steuern-deutsche" element={<GuidePlaceholder title="LLC Steuern für Deutsche — Was Sie wissen müssen" />} />

            {/* 404 Fallback */}
            <Route path="*" element={
              <div className="py-24 text-center">
                <div className="container-wide">
                  <h1 className="text-4xl font-heading font-bold text-navy-900 mb-4">404 — Seite nicht gefunden</h1>
                  <p className="text-slate-600 mb-8">Die gesuchte Seite existiert nicht.</p>
                  <a href="/" className="cta-primary">Zur Startseite</a>
                </div>
              </div>
            } />
          </Routes>
        </Layout>
      </BrowserRouter>
    </div>
  );
}

export default App;
